export const DEFAULT_EXTRA_UE_VAT = 'OO99999999999';

export const NOTE_EU_VAT =
    'Nota: inserire la partita IVA senza il codice che identifica la nazione. Selezionare la nazione nel campo dedicato';

export const VAT_VALUE_EXCEPTION = 'vat_value_exception';
